// extracted by mini-css-extract-plugin
export default {"feature":"FeaturesComponent_feature__Mq6Rh","featuresContent":"FeaturesComponent_featuresContent__aAxfr","featureWrapper":"FeaturesComponent_featureWrapper__uusud"};